import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const CarOutlineIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "CarOutlineIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M5.7062 10.7193L5.64819 9.58696C5.63534 9.33867 5.49562 9.11438 5.27847 8.9938L4.135 8.35835L3.3827 9.71182L5.6479 10.971C5.68962 10.8956 5.71078 10.8087 5.7062 10.7193Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M5.64737 11.7232C5.52339 11.7232 5.39795 11.6928 5.28231 11.6281L3.01696 10.3698C2.84252 10.2727 2.71364 10.111 2.65877 9.91894C2.60389 9.72685 2.6279 9.52105 2.72492 9.3466L3.47759 7.99318C3.67947 7.62861 4.13763 7.49728 4.50074 7.70112L5.64395 8.33618C6.08987 8.58315 6.3726 9.03593 6.40005 9.54652L6.45787 10.6814C6.46914 10.9107 6.41623 11.1381 6.30499 11.338C6.1668 11.584 5.911 11.7232 5.64737 11.7232ZM4.40615 9.42011L4.90009 9.69452L4.89666 9.62494L4.43164 9.37405L4.40615 9.42011Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.5536 10.7193L19.6116 9.58696C19.6245 9.33867 19.7642 9.11438 19.9813 8.9938L21.1248 8.35835L21.8771 9.71182L19.6119 10.971C19.5702 10.8956 19.549 10.8087 19.5536 10.7193Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.6124 11.7232C19.3487 11.7232 19.093 11.584 18.9548 11.338C18.8435 11.1381 18.7906 10.9117 18.8019 10.6824L18.8597 9.54849C18.8872 9.03593 19.1699 8.58316 19.6158 8.33618L20.759 7.70112C21.1202 7.49728 21.5808 7.6286 21.7822 7.99318L22.5348 9.3466C22.6319 9.52105 22.6559 9.72686 22.601 9.91894C22.5461 10.111 22.4172 10.2727 22.2428 10.3698L19.9775 11.6281C19.8618 11.6928 19.7364 11.7232 19.6124 11.7232ZM20.3053 10.7569C20.3053 10.7539 20.3057 10.752 20.3057 10.749L20.3053 10.7569ZM20.8325 9.38189L20.3449 9.70236L20.8536 9.42011L20.8325 9.38189Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.0552 19.733H17.4803C17.1324 19.733 16.7928 19.5909 16.5483 19.3449L15.5457 18.3335H9.71696L8.71487 19.3449C8.46888 19.5919 8.12929 19.733 7.78286 19.733H6.20794C5.48418 19.733 4.89567 19.144 4.89567 18.4207V10.9705C4.89567 10.7157 5.02504 10.4776 5.23918 10.3384C5.45381 10.2002 5.72282 10.1787 5.95656 10.2835C6.31672 10.457 9.29064 11.8437 12.6316 11.8437C15.898 11.8437 18.7377 10.5569 19.2737 10.2992C19.507 10.1865 19.7888 10.1992 20.0083 10.3364C20.2273 10.4746 20.3675 10.7118 20.3675 10.9705V18.4207C20.3675 19.144 19.779 19.733 19.0552 19.733ZM17.5607 18.2277H18.8622V12.1113C17.5347 12.6248 15.2061 13.3491 12.6316 13.3491C10.056 13.3491 7.73043 12.6258 6.40101 12.1113V18.2277H7.7025L8.70459 17.2163C8.95058 16.9693 9.29017 16.8282 9.6366 16.8282H15.6261C15.974 16.8282 16.3136 16.9703 16.5581 17.2163L17.5607 18.2277Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.6148 11.7232C19.5153 11.7232 19.4149 11.7036 19.3198 11.6634C19.31 11.6585 19.2806 11.6448 19.2708 11.6409C18.7318 11.3831 15.8779 10.0983 12.6316 10.0983C9.38522 10.0983 6.53136 11.3831 5.99234 11.6409C5.71402 11.7732 5.37199 11.7271 5.1451 11.5164C4.91871 11.3057 4.83492 10.9833 4.94762 10.6951L6.89544 5.7391C7.15074 4.88255 7.97348 4.26709 8.92264 4.26709H16.341C17.2995 4.26709 18.1227 4.88549 18.3893 5.80477L20.3155 10.6951C20.4263 10.9774 20.3572 11.2988 20.1396 11.5105C19.996 11.6497 19.8069 11.7232 19.6148 11.7232ZM8.92264 5.77242C8.64284 5.77242 8.39931 5.95667 8.31698 6.23108L6.98854 9.61612C8.3601 9.13786 10.4098 8.59296 12.6316 8.59296C14.8514 8.59296 16.8996 9.13688 18.2736 9.61612L16.9658 6.28989C16.8653 5.95373 16.6233 5.77243 16.341 5.77243L8.92264 5.77242Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default CarOutlineIcon;
